'use client';

import dynamic from 'next/dynamic';
import { Button } from '@/lib/components/ui/button';
import { IconBadge } from './IconBadge';
import type { Dictionary } from '@/lib/server/getDictionary';

const Map = dynamic(() => import('./Map'), { ssr: false, loading: () => null });

type Props = {
  name: string | null;
  address: string | null;
  code: string | null;
  lat: number | null;
  lng: number | null;
  dictionary: Dictionary;
};

export function WarehouseCard({ name, address, code, lat, lng, dictionary }: Props) {
  const hasCoordinates = lat != null && lng != null;

  return (
    <div>
      {hasCoordinates && <Map lat={lat} lng={lng} />}
      <div className="space-y-4 p-4 md:p-6">
        <div>
          <h2 className="text-xs font-medium uppercase tracking-wide text-on-surface-variant">
            {dictionary.order.ResponsibleDeliveryHub}
          </h2>
          <div className="mt-2 flex items-center gap-2">
            <IconBadge icon="warehouse" />
            <p className="text-sm font-normal">{name}</p>
          </div>
          {address && (
            <div className="mt-1 flex items-center gap-2">
              <IconBadge icon="location_on" />
              <p className="text-sm text-on-surface-variant">{address}</p>
            </div>
          )}
          {code && (
            <div className="mt-1 flex items-center gap-2">
              <IconBadge icon="tag" />
              <p className="text-xs text-on-surface-variant">
                {dictionary.general.code} {code}
              </p>
            </div>
          )}
        </div>

        {hasCoordinates && (
          <Button asChild className="w-full">
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="material-symbols-outlined text-base">directions</span>
              {dictionary.order.directionsToWarehouse}
            </a>
          </Button>
        )}

        <div className="flex items-start gap-2 rounded-xl border border-outline-variant px-3 py-2.5 text-xs text-on-surface-variant">
          <span className="material-symbols-outlined mt-0.5 shrink-0 text-base">notifications</span>
          <span>{dictionary.general.smsNotice}</span>
        </div>
      </div>
    </div>
  );
}
